// Общая настройка axios: токен в заголовке и обработка протухшей/отозванной сессии.
import axios from 'axios'
import { getToken, clearSession } from './auth'

export default function setupHttp(router) {
  axios.interceptors.request.use((config) => {
    const token = getToken()
    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  })

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response && error.response.status
      const url = (error.config && error.config.url) || ''
      // 401 на любом запросе, кроме самого входа — токен недействителен: на страницу входа.
      if (status === 401 && url.indexOf('/auth/login') === -1) {
        clearSession()
        const current = router.currentRoute
        if (current.path !== '/login') {
          router.push({ path: '/login', query: { redirect: current.fullPath } })
        }
      }
      return Promise.reject(error)
    }
  )
}
